import { get } from "lodash";

export const getIcons = (name) => {
    const icons = {
        close: "fa-regular fa-close",
    };
    return get(icons, name, "");
}